import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { menuControlFor, activeMenuControlFor } from './_get_menu_control';
import { CanonicalFontFamily, canonicalFontName, cssFontFamily } from './_fonts';

const NormalizeFontsOnPaste = Extension.create({
  name: 'normalizeFontsOnPaste',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('normalizeFontsOnPaste'),
        props: {
          transformPastedHTML(html) {
            const container = document.createElement('div');

            container.innerHTML = html;
            container.querySelectorAll('*').forEach((element) => {
              const fontFamily = (element.style || {})['font-family'];
              if (!fontFamily) {
                return;
              }

              const validFont = fontFamily.split(',').map(canonicalFontName).find(Boolean);

              if (validFont) {
                element.style['font-family'] = cssFontFamily(validFont);
              } else {
                element.style.removeProperty('font-family');
              }
            });

            return container.innerHTML;
          },
        },
      }),
    ];
  },
});

const syncMenu = ({ editor }) => {
  const font = editor.getAttributes('textStyle').fontFamily;
  const fontFamily = (font || 'Source Sans Pro').replace(/["']/g, '');
  const previousFontControl = activeMenuControlFor(editor, 'font:family');
  const currentFontControl = menuControlFor(editor, 'font:family', fontFamily);

  if (previousFontControl !== currentFontControl) {
    previousFontControl?.classList?.toggle('active', false);
    currentFontControl?.classList?.toggle('active', true);
  }
};

export default [
  CanonicalFontFamily.extend({
    onCreate: syncMenu,
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
  NormalizeFontsOnPaste,
];
